// V2 sign-in gate (BRIEFS C2.4). Every /app route except /app/login sits inside it.
// Signed in → starts the activity client (once) and shows the page.
// Not signed in → login screen. Server not reachable → a calm "trying again" screen
// (never signs Harsh out just because the internet is down).
import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppAuth } from '../../context/AppAuthContext';
import { getMySettings } from '../../api/v2';
import { setIdleSeconds, startActivity } from './activity';
import { APP_NAME, C, FONT, button } from './theme';

export function CenterMessage({ title, text, action }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: C.bg, color: C.text, fontFamily: FONT.ui, padding: 24,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }}>
        <div style={{ fontFamily: FONT.heading, fontSize: 22, fontWeight: 600 }}>{title}</div>
        {text && <div style={{ fontSize: 15, color: C.muted }}>{text}</div>}
        {action}
      </div>
    </div>
  );
}

export default function AppGate() {
  const { status, retry } = useAppAuth();
  const location = useLocation();
  const signedIn = status === 'signedIn';

  useEffect(() => {
    if (!signedIn) return;
    startActivity();
    getMySettings()
      .then((s) => setIdleSeconds(s.idle_seconds))
      .catch(() => { /* keep the default 2 minutes */ });
  }, [signedIn]);

  if (status === 'loading') return <CenterMessage title={APP_NAME} text="Opening…" />;
  if (status === 'offline') {
    return (
      <CenterMessage
        title="No internet"
        text="We will try again in a few seconds."
        action={<button type="button" style={button.primary} onClick={retry}>Try again now</button>}
      />
    );
  }
  if (!signedIn) return <Navigate to="/app/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
